import fromAnyToString from 'utils/converters/fromAnyToString';

const rankStartOfFirstFragment = (options) => {
  const strings = options?.strings;
  const needle = options.needle;

  return fromAnyToString(strings).startsWith(needle) ? 3 : 0;
};

export default rankStartOfFirstFragment;
